// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"Disclaimer_disclaimer__lcORq","background-blink":"Disclaimer_background-blink__B6Ne8","disclaimer-list":"Disclaimer_disclaimer-list__RogT7"};